import { useToggle } from 'react-use';

import {
   CurrentHealthcareOrganizationQuery,
   HealthcareOrganization,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';

import { HealthcareOrganizationDataPanel } from './data/HealthcareOrganizationDataPanel';
import { HealthcareOrganizationUpdatePanel } from './update/HealthcareOrganizationUpdatePanel';

type HealthcareOrganizationPanelProps = {
   readonly healthcareOrganization: HealthcareOrganization;
};

export const HealthcareOrganizationPanel = (props: HealthcareOrganizationPanelProps): JSX.Element => {
   const [editableMode, toggleEditableMode] = useToggle(false);

   if (editableMode) {
      const onDataChanged = (): void => {
         toggleEditableMode(false);
         refetchCqrsQuery(CurrentHealthcareOrganizationQuery);
      };

      return (
         <HealthcareOrganizationUpdatePanel
            onDataChanged={onDataChanged}
            healthcareOrganization={props.healthcareOrganization}
            onUpdateCanceled={toggleEditableMode}
         />
      );
   }

   return (
      <HealthcareOrganizationDataPanel
         healthcareOrganization={props.healthcareOrganization}
         onUpdateClicked={toggleEditableMode}
      />
   );
};
